export class OwnerUser {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/owner-user.ts